import { render, staticRenderFns } from "./IntegratedSalesView.vue?vue&type=template&id=0aaf7b24&scoped=true"
import script from "./IntegratedSalesView.vue?vue&type=script&lang=js"
export * from "./IntegratedSalesView.vue?vue&type=script&lang=js"
import style0 from "./IntegratedSalesView.vue?vue&type=style&index=0&id=0aaf7b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf7b24",
  null
  
)

export default component.exports